import React, { Component } from "react";
import { Grid } from "@mui/material";
import { connect } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import {
  deleteAccountFinaliseBegin,
  deleteAccountPrepareBegin,
} from "../actions/deleteaccountactions";
import { confirmAlert } from "react-confirm-alert";
import { moveToOptionsPage } from "../actions/routeactions";

class DeleteAccount extends Component {
  state = {
    password: "",
    code: 0,
  };

  constructor(props) {
    super(props);

    this.onDeleteAccount = this.onDeleteAccount.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onDeleteAccountConfirmation = this.onDeleteAccountConfirmation.bind(
      this
    );
    this.backToOptionsPage = this.backToOptionsPage.bind(this);
  }

  onDeleteAccount() {
    const { dispatch } = this.props;
    const { password, code } = this.state;
    dispatch(deleteAccountFinaliseBegin(password, code));
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(deleteAccountPrepareBegin());
  }

  backToOptionsPage() {
    const { dispatch } = this.props;
    dispatch(moveToOptionsPage())
  }

  onDeleteAccountConfirmation() {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="form" style={{ left: "30%" }}>
            <Grid
              container
              direction="column"
              justifyContent="center"
              alignContent="center"
            >
              <Grid item xs={12}>
                <p>Are you sure you want to delete your account?</p>
              </Grid>
              <Grid container direction="row" justify="center">
                <Grid item xs={4} />
                <Grid item xs={2}>
                  <button
                    className="bbe-button"
                    onClick={() => {
                      this.onDeleteAccount();
                      onClose();
                    }}
                  >
                    Yes
                  </button>
                </Grid>
                <Grid item xs={2}>
                  <button className="bbe-button" onClick={onClose}>
                    No
                  </button>
                </Grid>
                <Grid item xs={4} />
              </Grid>
            </Grid>
          </div>
        );
      },
    });
  }

  renderLoading() {
    const { loading } = this.props;
    return (
      <div className="loading_div">
        <div className="loading_spinner">
          <ClipLoader
            color="#FFFFFF"
            sizeUnit={"%"}
            size={100}
            loading={loading}
          />
        </div>
      </div>
    );
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  render() {
    const { loading } = this.props;

    return (
      <div>
        <Grid container alignItems="center" justify="center">
          <div className="form login_form">
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12}>
                <h1>Delete Account</h1>
              </Grid>
              <Grid item xs={12}>
                <h2>Password</h2>
              </Grid>
              <Grid item xs={12}>
                <input
                  name="password"
                  type="password"
                  className="textbox logintext"
                  onChange={this.onChange}
                />
              </Grid>
              <Grid item xs={12}>
                <h2>Code</h2>
              </Grid>
              <Grid item xs={12}>
                <input
                  name="code"
                  type="text"
                  className="textbox logintext"
                  onChange={this.onChange}
                />
              </Grid>
              <Grid item xs={12}>
                <button
                  className="bbe-button"
                  onClick={this.onDeleteAccountConfirmation}
                >
                  Delete Account
                </button>
              </Grid>
              <Grid item xs={12}>
                <p
                  className="hyperlink"
                  onClick={this.backToOptionsPage}
                >
                  <u>Back To Options</u>
                </p>
              </Grid>
            </Grid>
          </div>
        </Grid>
        {loading ? this.renderLoading() : <React.Fragment />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.deleteAccount.loading,
});

export default connect(mapStateToProps)(DeleteAccount);
